<template>
  <b-container class="p-3" fluid>
    <b-row>
      <b-col>
        <participant-table
          :attendee="project.attendee"
          :actual-attendee="project.actualAttendee"
          @finish="$apollo.queries.project.refetch()"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import gql from 'graphql-tag'
import ParticipantTable from '@/components/project/evaluation/ParticipantTable'

export default {
  apollo: {
    project: {
      query: gql`query GetProject($id: ID!) { project(id: $id) { attendee { instructor, student, others }, actualAttendee { instructor, student, others } }}`,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  components: {
    ParticipantTable
  },
  methods: {
    refetch () {
      this.$apollo.queries.project.refetch()
    }
  }
}
</script>

<style>

</style>
